/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindProtanomaly(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindProtanomaly',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M8 9c.908 0 1.746-.298 2.42-.8H5.58c.674.502 1.512.8 2.42.8M4.508 7h6.984c.23-.396.395-.834.478-1.3H4.03c.083.466.248.904.478 1.3M4 4.5c.058-.462.196-.9.4-1.3h7.2c.203.4.341.838.4 1.3zM5.334 2h5.333C9.957 1.378 9.023 1 8 1a4.03 4.03 0 0 0-2.666 1","fill":"#FF424D"}),createElement('path', {"d":"M8.467 10.48a5.5 5.5 0 0 1-5.468-3.19A4.001 4.001 0 0 0 4.5 15a4 4 0 0 0 3.967-4.52","fill":"#2FC862"}),createElement('path', {"d":"M7.5 11q0-.264.033-.52a5.5 5.5 0 0 0 5.468-3.19A4.001 4.001 0 0 1 11.5 15a4 4 0 0 1-4-4","fill":"#2496FF"}))
}
